import { SvgIcon, SvgIconProps, useTheme } from "@mui/material";
import ShiLogo from "../assets/shared-shi-logo.svg?react";
import InverseShiLogo from "../assets/inverse-shi-logo.svg?react";

/**
 * SHI logo component that automatically switches between light and dark variants.
 * Renders the appropriate logo SVG based on the current theme mode:
 * - Light theme: displays the standard SHI logo
 * - Dark theme: displays the inverse SHI logo for better visibility
 *
 * @param props - Standard MUI SvgIcon props (width, height, className, etc.)
 */
export const ShiSvgIcon = (props: SvgIconProps) => {
  const { palette } = useTheme();
  const isDarkMode = palette.mode === "dark";

  return (
    <SvgIcon
      {...props}
      inheritViewBox
      component={isDarkMode ? InverseShiLogo : ShiLogo}
    />
  );
};

export default ShiSvgIcon;
